import React, { useEffect } from "react";
import { useState } from "react";
import { NonAuthRoutes } from "../../constants/Constants";
import { useNavigate } from "react-router-dom";
import ATextField from "../../components/ATextField";
import { Icon, PrimaryButton } from "@fluentui/react";
import { AuthenticateOTPSchema } from "../../Schemas/LoginSchema";
import { encryptData } from "../../helpers/RSAUtility";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import { authenticateOTP, generateOTP } from "../../service/UserService";
import VDC_AIPoweredCloudPacs from "../../components/SVGComponents/Logo/VDC_AIPoweredCloudPacs";
import { useLocation } from "react-router-dom";
import { getEnv } from '../../helpers/EnvHelper';

const textFieldStyles = {
  errorMessage: {
    color: "#ff0000",
    fontWeight: "700",
    fontSize: "12px",
  },
  fieldGroup: {
    borderRadius: "7px",
  },
  field: {
    ":focus": {
      borderRadius: "7px",
    },
  },
  root: {
    color: "rgb(255,255,255) !important",
    border: "none !important",
  },
};
const Otp = () => {
  // const [email] = useState(
  //   localStorage.getItem("forgotPasswordEmail")
  // );
  const [username, setUsername] = useState(
    localStorage.getItem("forgotPasswordUsername")
  );
    // NEW: store which channels were used and the masked contacts
  const [otpSentInfo, setOtpSentInfo] = useState({
    emailSent: false,
    whatsappSent: false,
    email: localStorage.getItem("forgotPasswordEmail") || null,
    whatsappNumber: localStorage.getItem("forgotPasswordWhatsApp") || null
  });

  const [otp] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const [t] = useTranslation();
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [resendEnablingTime, setResendEnablingTime] = useState(30);

  const parseStoredBool = (val) => {
    if (val === null || val === undefined) return false;
    return val === "true" || val === true;
  };

  // useEffect(() => {
  //   const forgotPasswordUsername = localStorage.getItem(
  //     "forgotPasswordUsername"
  //   );
  //   if (forgotPasswordUsername && forgotPasswordUsername != null) {
  //     setUsername(forgotPasswordUsername);
  //   } else {
  //     navigate(NonAuthRoutes.LOGIN);
  //   }
  // }, []);

// inside component, near useNavigate:

// add at top: const location = useLocation(); (you already imported and used it)

useEffect(() => {
  const forgotPasswordUsername = localStorage.getItem("forgotPasswordUsername");

  const navData = location && location.state ? location.state.otpResponse || location.state : null;
  if (navData && (typeof navData.emailSent !== "undefined" || typeof navData.whatsappSent !== "undefined" || navData.email || navData.whatsappNumber)) {
    const dto = navData;

    // If backend explicitly returned empty email or emailSent=false -> clear stored email
    if (typeof dto.emailSent !== "undefined" && !dto.emailSent) {
      localStorage.removeItem("forgotPasswordEmail");
      localStorage.removeItem("forgotPasswordEmailSent");
      console.debug("[Otp] Backend says emailSent=false -> cleared forgotPasswordEmail from localStorage");
    } else if (dto.email) {
      localStorage.setItem("forgotPasswordEmail", dto.email);
    }

    // If backend explicitly returned whatsappSent=false or empty whatsappNumber -> clear stored whatsapp
    if (typeof dto.whatsappSent !== "undefined" && !dto.whatsappSent) {
      localStorage.removeItem("forgotPasswordWhatsApp");
      localStorage.removeItem("forgotPasswordWhatsappSent");
      console.debug("[Otp] Backend says whatsappSent=false -> cleared forgotPasswordWhatsApp from localStorage");
    } else if (dto.whatsappNumber) {
      localStorage.setItem("forgotPasswordWhatsApp", dto.whatsappNumber);
    }

    // persist the flags if backend provided them
    if (typeof dto.emailSent !== "undefined") {
      localStorage.setItem("forgotPasswordEmailSent", dto.emailSent.toString());
    }
    if (typeof dto.whatsappSent !== "undefined") {
      localStorage.setItem("forgotPasswordWhatsappSent", dto.whatsappSent.toString());
    }

    // set state strictly from DTO (prefer explicit flags, fallback to presence only if flags not provided)
    setOtpSentInfo({
      emailSent: typeof dto.emailSent !== "undefined" ? !!dto.emailSent : !!dto.email,
      whatsappSent: typeof dto.whatsappSent !== "undefined" ? !!dto.whatsappSent : !!dto.whatsappNumber,
      email: dto.email || localStorage.getItem("forgotPasswordEmail"),
      whatsappNumber: dto.whatsappNumber || localStorage.getItem("forgotPasswordWhatsApp"),
    });

    // ensure username exist
    setUsername(localStorage.getItem("forgotPasswordUsername") || "");
    return;
  }

  // fallback behavior (no nav state)
  if (forgotPasswordUsername && forgotPasswordUsername != null) {
    setUsername(forgotPasswordUsername);

    const emailStored =
      localStorage.getItem("forgotPasswordEmail") ||
      localStorage.getItem("2faEmail");
    const whatsappStored =
      localStorage.getItem("forgotPasswordWhatsApp") ||
      localStorage.getItem("2faWhatsApp");
    const emailSentStored =
      localStorage.getItem("forgotPasswordEmailSent") ||
      localStorage.getItem("2faEmailSent");
    const whatsappSentStored =
      localStorage.getItem("forgotPasswordWhatsappSent") ||
      localStorage.getItem("2faWhatsappSent");

    // IMPORTANT: prefer explicit stored boolean flags over presence of email string
    const emailSent = parseStoredBool(emailSentStored);
    const whatsappSent = parseStoredBool(whatsappSentStored);

    setOtpSentInfo({
      emailSent: emailSent || (!!emailStored && emailSentStored === null), // if flag missing, fall back to presence
      whatsappSent: whatsappSent || (!!whatsappStored && whatsappSentStored === null),
      email: emailStored || null,
      whatsappNumber: whatsappStored || null,
    });

  } else {
    navigate(NonAuthRoutes.LOGIN);
  }
}, [location]);



  // const handleResend = async () => {
  //   const encryptedUsername = encryptData(
  //     localStorage.getItem("forgotPasswordUsername")
  //   );
  //   const response = await generateOTP(encryptedUsername);
  //   if (response.status === 200) {
  //     localStorage.setItem("forgotPasswordEmail", response.data.data.email);
  //     setResendEnablingTime(30);
  //     setIsResendEnabled(false);
  //   }
  // };
  const handleResend = async () => {
  const encryptedUsername = encryptData(
    localStorage.getItem("forgotPasswordUsername")
  );
  //console.debug("[Otp] handleResend - calling generateOTP for", localStorage.getItem("forgotPasswordUsername"));
  const response = await generateOTP(encryptedUsername);
  //console.debug("[Otp] handleResend - response:", response && response.data);

  if (response && response.status === 200) {
    const data = (response.data && response.data.data) ? response.data.data : {};

    // If backend tells no email, clear previously stored email
    if (typeof data.emailSent !== "undefined" && !data.emailSent) {
      localStorage.removeItem("forgotPasswordEmail");
      localStorage.removeItem("forgotPasswordEmailSent");
      //console.debug("[Otp] handleResend - backend returned emailSent=false, cleared forgotPasswordEmail");
    } else if (data.email) {
      localStorage.setItem("forgotPasswordEmail", data.email);
      localStorage.setItem("forgotPasswordEmailSent", (!!data.emailSent).toString());
    }

    if (typeof data.whatsappSent !== "undefined" && !data.whatsappSent) {
      localStorage.removeItem("forgotPasswordWhatsApp");
      localStorage.removeItem("forgotPasswordWhatsappSent");
      //console.debug("[Otp] handleResend - backend returned whatsappSent=false, cleared forgotPasswordWhatsApp");
    } else if (data.whatsappNumber) {
      localStorage.setItem("forgotPasswordWhatsApp", data.whatsappNumber);
      localStorage.setItem("forgotPasswordWhatsappSent", (!!data.whatsappSent).toString());
    }

    setOtpSentInfo({
      emailSent: typeof data.emailSent !== "undefined" ? !!data.emailSent : !!data.email,
      whatsappSent: typeof data.whatsappSent !== "undefined" ? !!data.whatsappSent : !!data.whatsappNumber,
      email: data.email || localStorage.getItem("forgotPasswordEmail"),
      whatsappNumber: data.whatsappNumber || localStorage.getItem("forgotPasswordWhatsApp")
    });

    setResendEnablingTime(30);
    setIsResendEnabled(false);
  } else {
    console.debug("[Otp] handleResend - non-200 response", response);
  }
};



  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        username,
        otp,
      },
      validationSchema: () => AuthenticateOTPSchema(t),
      onSubmit: async (values, action) => {
        const encryptedUsername = encryptData(values.username);
        const encryptedOTP = encryptData(values.otp);

        const response = await authenticateOTP(encryptedUsername, encryptedOTP);

        if (response.status === 200) {
          // localStorage.setItem("forgotPasswordUsername", values.username);
          localStorage.removeItem("forgotPasswordEmail");

          localStorage.removeItem("forgotPasswordWhatsApp");
          localStorage.removeItem("forgotPasswordEmailSent");
          localStorage.removeItem("forgotPasswordWhatsappSent");
          
          navigate(NonAuthRoutes.RESETPASSWORD);
        } else {
          setIsAuthenticated(false);
          if (
            !(
              response.data.message.includes("1") ||
              response.data.message.includes("2") ||
              response.data.message.includes("required")
            )
          ) {
            setResendEnablingTime(0);
            setIsResendEnabled(false);
          }
          setErrorMessage(response.data.message);
        }

        action.resetForm();
      },
    });

  useEffect(() => {
    if (!isResendEnabled) {
      setTimeout(() => {
        if (resendEnablingTime === 0) {
          setIsResendEnabled(true);
        } else {
          setResendEnablingTime(resendEnablingTime - 1);
        }
      }, 1000);
    }
  }, [resendEnablingTime, isResendEnabled]);

  return (
    <>
      <div
        className="ms-Grid container"
        dir="ltr"
        style={{
          height: "100%",
          width: "100%",
          padding: "0px",
          overflowY: "hidden",
          backgroundColor: "white"
        }}
      >
        <div className="ms-Grid-row" style={{ width: "100%", height: "100vh" }}>
          <div
            className="ms-Grid-col ms-xl6 ms-hiddenLgDown"
            style={{ padding: "0", height: "100%" }}
          >
            {getEnv("REACT_APP_VDC_PLATFORM") === "true" ? (
              <VDC_AIPoweredCloudPacs />
            ) : (
              <img
                className="ai-powered-cloud-image"
                src={`${window.location.origin}/images/AIPoweredCloudPacs.png`}
                alt="AI Powered Cloud Pacs"
              />
            )}
          </div>
          <div
            className="ms-Grid-col ms-sm12 ms-md10 ms-lg8 ms-xl4 ms-xlPush1 ms-lgPush2 ms-mdPush1"
            style={{ padding: "0" }}
          >
            <div className="login-form-container">
              <form>
                {/* <p
                  className="ms-fontSize-12 ms-fontWeight-semibold"
                  style={{
                    marginBottom: "20px",
                    lineHeight: "16px",
                  }}
                >
                  An OTP has been sent to your registered email id -{" "}
                  <span style={{ fontWeight: "bold" }}>{email}</span>
                  <br></br>
                  <br></br>
                  In case you do not see the email in your inbox, please check
                  your spam or junk mail folder before requesting for a new OTP.
                </p> */}
                <div
                  className="ms-fontSize-12 ms-fontWeight-semibold"
                  style={{ marginBottom: "20px", lineHeight: "16px" }}
                >
                  {otpSentInfo.whatsappSent && (
                    <div style={{ marginTop: otpSentInfo.emailSent ? 8 : 0 }}>
                      An OTP has been sent to your registered WhatsApp number -{" "}
                      <span style={{ fontWeight: "bold" }}>{otpSentInfo.whatsappNumber}</span>
                    </div>
                  )}
                  {otpSentInfo.emailSent && (
                    <>
                      <div>
                        An OTP has been sent to your registered email id -{" "}
                        <span style={{ fontWeight: "bold" }}>{otpSentInfo.email}</span>
                      </div>
                      <div style={{ marginTop: "8px", marginBottom: "8px", fontSize: "13px" }}>
                        In case you do not see the email in your inbox, please check
                        your spam or junk mail folder before requesting for a new OTP.
                      </div>
                    </>
                  )}

                  

                  {!otpSentInfo.emailSent && !otpSentInfo.whatsappSent && (
                    <div>An OTP has been sent — please check your available channels.</div>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    margin: "30px 0 5px",
                    color: "#ff0000",
                  }}
                >
                  {!isAuthenticated && (
                    <div
                      className="ms-fontSize-1"
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Icon
                        iconName="InfoSolid"
                        className="ms-fontSize-14"
                        style={{ marginRight: "5px" }}
                      ></Icon>
                      <p className="ms-fontSize-12 login-form-error-messages ms-fontWeight-bold">
                        {errorMessage}
                      </p>
                    </div>
                  )}
                </div>
                <div>
                  <ATextField
                    name="username"
                    label="Username"
                    onChange={handleChange}
                    value={values.username}
                    onBlur={handleBlur}
                    errorMessage={touched.username && errors.username}
                    styles={textFieldStyles}
                    disabled={true}
                  />
                  <ATextField
                    name="otp"
                    label="OTP"
                    onChange={handleChange}
                    value={values.otp}
                    onBlur={handleBlur}
                    errorMessage={touched.otp && errors.otp}
                    styles={textFieldStyles}
                  />
                </div>
                <div
                  style={{
                    marginTop: "30px",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <PrimaryButton
                    className="ms-fontSize-14"
                    text={t("button.reset-password")}
                    style={{ width: "150px" }}
                    onClick={handleSubmit}
                  />
                  <PrimaryButton
                    className="ms-fontSize-14"
                    text={t("button.resend-otp")}
                    style={{ width: "150px" }}
                    onClick={handleResend}
                    disabled={!isResendEnabled}
                  />
                </div>
                {!isResendEnabled && (
                  <div
                    style={{
                      marginTop: "5px",
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                    }}
                  >
                    <span style={{ fontSize: "13px" }}>
                      Resend OTP in {resendEnablingTime}s
                    </span>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Otp;
